import {
  isExisting,
  isNonRequiredTextOfMaxLength,
  isRequiredTextOfMaxLength,
  isValidMeasurementCode,
  isValidSsn
} from "../validations";
import {MeasurementType} from "../measurement-models";
import {InitiateMeasurementFormModel} from "./initiate-measurement-data";
import {MAX_CHARACTERS_IN_TEXT} from "../utils";
import {FormValidator} from "../../tools/form/form-validator";

export function createInitiateMeasurementValidationFunctionMap(model: InitiateMeasurementFormModel) {
  return new Map<keyof InitiateMeasurementFormModel, () => boolean>()

    .set("code", () => validateCode(model.code, model.ssn))
    .set("reasonForStudy", () => isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, model.reasonForStudy))
    .set("type", () => isExisting(model.type))
    .set("ssn", () => validateSsn(model.code, model.ssn))
    .set("deviceSerial", () => isNonRequiredTextOfMaxLength(100, model.deviceSerial));
}

export function validateCode(code?: string, ssn?: string): boolean {
  if (isExisting(code) && isValidMeasurementCode(code)) {
    return true;
  }
  if (!isExisting(code)) {
    return isExisting(ssn) && isValidSsn(ssn);
  }
  return false;
}

export function validateSsn(code?: string, ssn?: string): boolean {
  if (isExisting(ssn) && isValidSsn(ssn)) {
    return true;
  }
  if (!isExisting(ssn)) {
    return isExisting(code) && isValidMeasurementCode(code);
  }
  return false;
}

export class InitiateMeasurementValidator extends FormValidator<InitiateMeasurementFormModel> {

  constructor(hospitalInformation: InitiateMeasurementFormModel) {
    super(createInitiateMeasurementValidationFunctionMap(hospitalInformation));
  }

}

